import { render, staticRenderFns } from "./SalaryPayFailDlg.vue?vue&type=template&id=89aa5a16&scoped=true&"
import script from "./SalaryPayFailDlg.vue?vue&type=script&lang=js&"
export * from "./SalaryPayFailDlg.vue?vue&type=script&lang=js&"
import style0 from "./SalaryPayFailDlg.vue?vue&type=style&index=0&id=89aa5a16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89aa5a16",
  null
  
)

export default component.exports